// extracted by mini-css-extract-plugin
export default {"product_results_container":"ProductResults_product_results_container__w8xIE","no_results":"ProductResults_no_results__oHBNv"};